import type { Group } from 'three';

import { PART_TYPES } from '../constants';
import type { AssemblyJson } from '../contracts/assembly';
import {
  createAdditionalFeedback,
  disposeAdditionalFeedback,
} from '../renderer/creation-utils';
import type { FeatureOrFeedBackItem } from '../renderer/creation-utils';
import type { Renderer } from '../renderer/renderer';
import { OptimalBoundingBoxGeometry } from './OptimalBoundingBoxGeometry';
import type { PMIData } from './pmi/PMIData';

export class Assembly {
  public readonly id?: string;
  public readonly name: string;
  public readonly type: PART_TYPES.STEP;
  public readonly optimalBoundingBoxGeometry: OptimalBoundingBoxGeometry | null;
  public additionalFeedback: Record<string, Group> = {}; //populated by this.createAdditionalFeedback
  public pmi?: PMIData;
  private isDisposed?: boolean;

  constructor(data: AssemblyJson, private readonly renderer: Renderer) {
    this.id = data.partFileUuid || data.uuid; //pcad sends uuid
    this.name = data.name;
    this.type = PART_TYPES.STEP;
    const optimalBoundingBoxData =
      data.optimalBoundingBoxData || data.optimalBoundingBox;
    this.optimalBoundingBoxGeometry = optimalBoundingBoxData
      ? OptimalBoundingBoxGeometry.fromRawData(optimalBoundingBoxData)
      : null;
  }

  public dispose() {
    if (this.isDisposed) return;
    this.isDisposed = true;
    disposeAdditionalFeedback(this.additionalFeedback);
    if (this.pmi) {
      this.pmi.dispose();
    }
    if (this.optimalBoundingBoxGeometry) {
      this.optimalBoundingBoxGeometry.dispose();
    }
  }

  public createAdditionalFeedback(
    featuresOrFeedbackItems: Iterable<FeatureOrFeedBackItem>,
  ): boolean {
    return createAdditionalFeedback(
      this,
      featuresOrFeedbackItems,
      this.renderer,
    );
  }
}
export default Assembly;
